import Vue from 'vue'
import Vuex, { mapState, mapMutations } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import moment from 'moment'
import { forOwn } from 'lodash'

import tabs from './modules/tabs'
import snackbar from './modules/snackbar'
import acl from './modules/acl'
import videoCall from './modules/videoCall'

Vue.use(Vuex)

const initialState = () => ({
  token: null,
  earliestTransactionAt: null,
  title: '',
  userId: null,
  reports: [],
  dashboardUrl: null,
})

const initialModules = () => ({
  tabs,
  snackbar,
  acl,
  videoCall,
})

export default new Vuex.Store({
  state: initialState,

  getters: {
    earliestTransactionTimestamp: state => {
      return state.earliestTransactionAt || moment().unix()
    }
  },

  mutations: {
    LOGIN (state, token) {
      state.token = token
    },

    LOGOUT (state) {
      forOwn(initialState(), (value, key) => {
        state[key] = value
      })

      forOwn(initialModules(), (value, key) => {
        state[key] = value.state
      })
    },

    UPDATE_TITLE (state, title) {
      state.title = title
    },

    USER_ID (state, id) {
      state.userId = id
    },

    SET_REPORTS (state, reports) {
      state.reports = reports
    },

    SET_DASHBOARD_URL (state, dashboardUrl) {
      state.dashboardUrl = dashboardUrl
    },

    SET_REPORT_TYPE (state, reportType) {
      state.reportType = reportType
    },
  },

  plugins: [
    createPersistedState({
      paths: [ 'token', 'earliestTransactionAt', 'reports', 'acl', 'dashboardUrl', 'reportType' ],
      storage: window.sessionStorage
    })
  ],

  modules: initialModules()
})

export function mapStateTwoWay (namespace, stateMapping, mutationsMapping) {
  const mappedState = mapState(namespace, stateMapping)
  const mappedMutations = mapMutations(namespace, mutationsMapping)
  const result = {}
  for (const key in mappedState) {
    result[ key ] = {
      set (value) {
        mappedMutations[ key ].call(this, value)
      },
      get () {
        return mappedState[ key ].call(this)
      }
    }
  }
  return result
}



// WEBPACK FOOTER //
// ./src/store/index.js